function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M3.582,14.523h20.631L3.582,1.604v27.509h20.631L3.582,8.481v6.043Z",
    style: {
      fill: "#dc143c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.358,30H2.695V0l24.61,15.412h-15.536l14.588,14.588ZM4.471,28.224h17.6l-12.813-12.812h-4.787v12.812ZM9.993,13.636h11.13L4.471,3.208v4.906l5.523,5.523ZM4.471,13.636h3.011l-3.011-3.012v3.012Z",
    style: {
      fill: "#003893"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M3.582,14.523h20.631L3.582,1.604v27.509h20.631L3.582,8.481v6.043Z",
    style: {
      fill: "#dc143c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.632,9.678c.892,2.269,3.454,3.386,5.724,2.494,1.142-.449,2.045-1.352,2.494-2.494,0,2.269-1.84,4.109-4.109,4.109s-4.109-1.84-4.109-4.109",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.741,
    cy: 11.591,
    r: 1.912,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M9.472,9.826l-.212-.842-.518.692",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1",
    "data-name": "b",
    d: "M10.092,10.24l.126-.859-.743.441",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2",
    "data-name": "b",
    d: "M10.506,10.86l.445-.746-.856.123",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b3",
    "data-name": "b",
    d: "M10.651,11.591l.696-.518-.838-.213",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b4",
    "data-name": "b",
    d: "M10.506,12.322l.842-.212-.692-.518",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b5",
    "data-name": "b",
    d: "M10.092,12.942l.859.126-.441-.743",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b6",
    "data-name": "b",
    d: "M8.009,9.826l.212-.842.518.692",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b7",
    "data-name": "b",
    d: "M7.39,10.24l-.126-.86.743.441",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b8",
    "data-name": "b",
    d: "M6.975,10.86l-.445-.746.856.123",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b9",
    "data-name": "b",
    d: "M6.83,11.591l-.696-.518.838-.213",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b10",
    "data-name": "b",
    d: "M6.975,12.322l-.842-.212.692-.518",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b11",
    "data-name": "b",
    d: "M7.39,12.942l-.859.126.441-.743",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.741,
    cy: 21.818,
    r: 2.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M9.466,24.523l-.725,1.708-.725-1.708",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e1",
    "data-name": "e",
    d: "M8.016,19.113l.725-1.708.725,1.708",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e2",
    "data-name": "e",
    d: "M6.036,22.543l-1.708-.725,1.708-.725",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e3",
    "data-name": "e",
    d: "M11.445,21.093l1.708.725-1.708.725",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e4",
    "data-name": "e",
    d: "M8.016,24.523l-1.482,1.116.226-1.842",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e5",
    "data-name": "e",
    d: "M9.465,19.112l1.482-1.117-.226,1.842",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e6",
    "data-name": "e",
    d: "M6.035,21.094l-1.116-1.482,1.842.226",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7",
    "data-name": "e",
    d: "M11.445,22.542l1.116,1.482-1.842-.226",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e8",
    "data-name": "e",
    d: "M6.76,23.798l-1.842.226,1.116-1.482",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e9",
    "data-name": "e",
    d: "M10.72,19.838l1.842-.226-1.116,1.482",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e10",
    "data-name": "e",
    d: "M6.76,19.838l-.226-1.842,1.482,1.117",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e11",
    "data-name": "e",
    d: "M10.721,23.798l.226,1.842-1.482-1.117",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/NP.a2e9d745cc166a64ca5c3e07169f6e7c.svg";
export { ForwardRef as ReactComponent };